import { render } from "./PremiumHomeDeliveryIcon.vue?vue&type=template&id=6c1dfd61"
import script from "./PremiumHomeDeliveryIcon.vue?vue&type=script&lang=js"
export * from "./PremiumHomeDeliveryIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__